import React from 'react';
import Text from '../../../../../global/text/text';
import { CopyButton } from '../../../../../global/copy-button/copy-button';
import './text-with-copy-btn.scss';

interface IProps {
    message: string;
    handleCopyClick?: () => void;
}

const TextWithCopyBtn = (props: IProps) => {
    const { message, handleCopyClick } = props;

    return (
        <div className='text-with-copy'>
            <Text className='text-with-copy__label' message={message} withEllipsis />
            <CopyButton className='text-with-copy__button' copyValue={message} onCopy={handleCopyClick} withoutIcon />
        </div>
    );
};

export default TextWithCopyBtn;